import { useEffect } from "react";

const useKeyboardTableNavigation = ({
  isActive = true,
  containerRef, // ✅ NEW
  searchTerms = "",
  suggestions = [],
  modals = {},
  onEnter,
  selector = "table tbody tr",
}) => {
  useEffect(() => {
    if (!isActive || !containerRef?.current) return;

    const root = containerRef.current;

    // ✅ reset tabindex ONLY inside this tab
    root.querySelectorAll(selector).forEach((row) => {
      row.tabIndex = -1;
    });

    const handleKey = (e) => {
      if (!["ArrowDown", "ArrowUp", "Enter"].includes(e.key)) return;

      const termsArray = Array.isArray(searchTerms)
        ? searchTerms
        : [searchTerms];

      const suggestionsArray = Array.isArray(suggestions?.[0])
        ? suggestions.flat()
        : suggestions;

      const hasSearchActive = termsArray.some(
        (t) => typeof t === "string" && t.trim() !== "",
      );

      if (hasSearchActive) return;
      if (suggestionsArray?.length) return;
      if (Object.values(modals).some(Boolean)) return;

      const tableRows = Array.from(root.querySelectorAll(selector));

      if (!tableRows.length) return;

      e.preventDefault();

      const currentRow = document.activeElement?.closest("tr");
      let currentIndex = tableRows.indexOf(currentRow);

      // 🌱 seed focus
      if (currentIndex === -1) {
        const startIndex = e.key === "ArrowUp" ? tableRows.length - 1 : 0;

        tableRows[startIndex].tabIndex = 0;
        tableRows[startIndex].focus();
        return;
      }

      if (e.key === "Enter") {
        const item = tableRows[currentIndex].dataset?.item
          ? JSON.parse(tableRows[currentIndex].dataset.item)
          : null;

        if (item && onEnter) onEnter(item);
        return;
      }

      tableRows[currentIndex].tabIndex = -1;

      const nextIndex =
        e.key === "ArrowDown"
          ? (currentIndex + 1) % tableRows.length
          : (currentIndex - 1 + tableRows.length) % tableRows.length;

      const nextRow = tableRows[nextIndex];
      nextRow.tabIndex = 0;
      nextRow.focus();
    };

    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [
    isActive,
    containerRef,
    searchTerms,
    suggestions,
    modals,
    onEnter,
    selector,
  ]);
};

export default useKeyboardTableNavigation;
